import { render, staticRenderFns } from "./posvenda.vue?vue&type=template&id=715bae26&scoped=true"
import script from "./posvenda.vue?vue&type=script&lang=js"
export * from "./posvenda.vue?vue&type=script&lang=js"
import style0 from "./posvenda.vue?vue&type=style&index=0&id=715bae26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715bae26",
  null
  
)

export default component.exports